import React, { createContext, useState, useEffect, useContext } from "react";
import api from "../../services/api";
import useWhatsApps from "../../hooks/useWhatsApps";
import WavoipPhoneWidget from "../../components/WavoipCall";
import { AuthContext } from "../Auth/AuthContext";

const WhatsAppsContext = createContext();
const isUnauthorizedError = (error) =>
  error?.response?.status === 401 || error?.response?.status === 403;

const WhatsAppsProvider = ({ children }) => {
  // Add fallback values to prevent destructuring errors
  const whatsAppData = useWhatsApps();
  const { loading = false, whatsApps = [] } = whatsAppData || {};
  const { user, isAuth, loading: authLoading } = useContext(AuthContext);
  
  const [wavoipToken, setWavoipToken] = useState(null);
  const [loadingSession, setLoadingSession] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (authLoading) {
      return;
    }

    if (!isAuth) {
      setWavoipToken(null);
      setLoadingSession(false);
      setError(null);
      return;
    }

    if (!user?.id) {
      setWavoipToken(null);
      setLoadingSession(false);
      return;
    }

    const fetchSession = async () => {
      try {
        setLoadingSession(true);
        const { data } = await api.get("/call/historical/user/whatsapp");

        // let wavoipToken  = "";
        // for(const d of data){
        //   if(d?.wavoip){
        //     wavoipToken = d.wavoip;
        //     break;
        //   }
        // }
        setWavoipToken(data?.whatsapp?.wavoip || null);
        setError(null);
      } catch (err) {
        if (!isUnauthorizedError(err)) {
          console.error("Erro fetchSession:", err);
        }
        setError(err);
        setWavoipToken(null);
      } finally {
        setLoadingSession(false);
      }
    };
    fetchSession();
  }, [authLoading, isAuth, user?.id]);


  return (
    <WhatsAppsContext.Provider value={{ whatsApps, loading, error }}>
      {children}
      {wavoipToken && (
        <WavoipPhoneWidget
          token={wavoipToken}
          position="bottom-right"
          name={user?.company?.name || "waVoip"}
          country="BR"
          autoConnect={true}
          onCallStarted={(data) => {
            if (process.env.NODE_ENV !== "production")
              console.log("Chamada iniciada:", data);
          }}
          onCallEnded={(data) => {
            if (process.env.NODE_ENV !== "production")
              console.log("Chamada finalizada:", data);
          }}
          onConnectionStatus={(status) => {
            if (process.env.NODE_ENV !== "production")
              console.log("Status:", status);
          }}
          onError={(error) => console.error("Erro:", error)}
        />
      )}
    </WhatsAppsContext.Provider>
  );
};

export { WhatsAppsContext, WhatsAppsProvider };
